import { EiAddStudent } from 'src/app/modules/ei-transition/models/ei-add-student.model';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export class StudentSearchNewStudentRequest {
    lastName: string;
    middleName: string;
    firstName: string;
    gender: IReferenceData;
    dob: Date;
    homeBorough: IReferenceData;
    streetName: string;
    houseNumber: string;
    city: string;
    state: IReferenceData;
    zip: number;
    guardianRelationship: IReferenceData;
    guardianFirstName: string;
    guardianLastName: string;
    schoolDistrict: IReferenceData;
    apartmentNumber: string;
    studentSk: string;
    constructor(data?: EiAddStudent) {
        if (data) {
            const fullStreetAddress: string = data.childAddressStreet1?.trim() || '';
            const [firstPart, ...remainingParts]: string[] = fullStreetAddress.split(' ');
            const isStreetNumber: boolean = /^\d+[a-zA-Z0-9\-]*$/.test(firstPart || '');
            const parsedStreetNumber: string = isStreetNumber ? firstPart : '';
            const parsedStreetName: string = isStreetNumber
                ? remainingParts.join(' ').trim()
                : fullStreetAddress;

            this.lastName = data.childLastName;
            this.middleName = data.childMiddleName;
            this.firstName = data.childFirstName;

            // nothing for gender
            this.dob = data.dob;
            this.homeBorough = data.borough;
            this.streetName = parsedStreetName;
            this.houseNumber = parsedStreetNumber;
            this.apartmentNumber = data.childAddressStreet2 !== undefined ? data.childAddressStreet2 : '';

            this.city = data.childAddressCity;
            this.state = data.childAddressState;

            this.zip = data.childAddressZip;
            this.guardianRelationship = data.relationship;
            this.guardianFirstName = data.parentFirstName;
            this.guardianLastName = data.parentLastName;
            this.schoolDistrict = data.homeDistrict;
            this.studentSk = data?.studentSk;
        }
    }

    readonly id: string = '';
}